module.exports = __webpack_public_path__ + "media/images/products/products/h4-4c728d1ae3defaccd9049f19a3efa33c.png";